// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ApiError, type SchedulerListe, SchedulerScope } from "../../api";
import { useSearchSchedulers as useGetter } from "../hooks";
import { type QueryKey, useQuery, type UseQueryOptions } from "react-query";

export type SchedulersQuery = {
  search?: string;
  scope?: SchedulerScope;
  mandantId?: string;
  selectableForAufgabe?: string;
  aufgabeId?: string;
  filtered?: string;
  page?: number;
  limit?: number;
  sort?: string;
};

export function useSchedulersQueryKey(query: SchedulersQuery = {}): QueryKey {
  return ["api", "v1", "schedulers", query];
}

export function useSchedulers(
  query: SchedulersQuery = {},
  options: Omit<
    UseQueryOptions<SchedulerListe, ApiError>,
    "queryKey" | "queryFn"
  > = {}
): SchedulerListe {
  const getter = useGetter();
  return useQuery(useSchedulersQueryKey(query), () => getter(query), options)
    .data!;
}
